import {
  GetSnapshot,
  PostSnapshotByPeriodo,
  PutSnapshotEvaluacion,
  DeleteSnapshotEvaluacion,
  GetResumen,
  PutCambiarVendedor,
  GetLiderClubes,
  GetLiderReporte,
  State as ComisionAnualidadState
} from "../../../reducers/comisionAnualidad";

export interface ReporteLiderStore
  extends GetSnapshot,
    PostSnapshotByPeriodo,
    PutSnapshotEvaluacion,
    DeleteSnapshotEvaluacion,
    GetResumen,
    PutCambiarVendedor,
    GetLiderClubes,
    GetLiderReporte {}

export const reporteLiderStore: (state) => ReporteLiderStore = state => {
  const comisionAnualidad: ComisionAnualidadState = state.comisionAnualidad;

  return {
    snapshot: comisionAnualidad.snapshot,
    gettingSnapshot: comisionAnualidad.gettingSnapshot,
    gettingSnapshotError: comisionAnualidad.gettingSnapshotError,

    postSnapshotResult: comisionAnualidad.postSnapshotResult,
    postingSnapshotByPeriodo: comisionAnualidad.postingSnapshotByPeriodo,
    postingSnapshotByPeriodoError:
      comisionAnualidad.postingSnapshotByPeriodoError,

    putSnapshotEvaluacionResult: comisionAnualidad.putSnapshotEvaluacionResult,
    puttingSnapshotEvaluacion: comisionAnualidad.puttingSnapshotEvaluacion,
    puttingSnapshotEvaluacionError:
      comisionAnualidad.puttingSnapshotEvaluacionError,

    deleteSnapshotEvaluacionResult:
      comisionAnualidad.deleteSnapshotEvaluacionResult,
    deletingSnapshotEvaluacion: comisionAnualidad.deletingSnapshotEvaluacion,
    deletingSnapshotEvaluacionError:
      comisionAnualidad.deletingSnapshotEvaluacionError,

    resumenSnapshot: comisionAnualidad.resumenSnapshot,
    gettingResumenSnapshot: comisionAnualidad.gettingResumenSnapshot,
    gettingResumenSnapshotError: comisionAnualidad.gettingResumenSnapshotError,

    cambiarVendedorResult: comisionAnualidad.cambiarVendedorResult,
    puttingCambiarVendedor: comisionAnualidad.puttingCambiarVendedor,
    puttingCambiarVendedorError: comisionAnualidad.puttingCambiarVendedorError,

    liderClubes: comisionAnualidad.liderClubes,
    gettingLiderClubes: comisionAnualidad.gettingLiderClubes,
    gettingLiderClubesError: comisionAnualidad.gettingLiderClubesError,

    liderReporte: comisionAnualidad.liderReporte,
    gettingLiderReporte: comisionAnualidad.gettingLiderReporte,
    gettingLiderReporteError: comisionAnualidad.gettingLiderReporteError
  };
};
